goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ChevronLeft$default");
shadow.js.shim.module$$carbon$icons_react$es$ChevronLeft$default = shadow.js.require(354, {}).default;
